import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { UbiModule } from '../theme/ubi.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DynamicGridComponent } from './components/dynamic-grid/dynamic-grid.component';
import { DynamicDetailComponent } from './components/dynamic-detail/dynamic-detail.component';
import { DynamicListDetailComponent } from './components/dynamic-list-detail/dynamic-list-detail.component';
import { DynamicFormModule } from '../dynamic-form/dynamic-form.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    UbiModule,
    DynamicFormModule
  ],
  declarations: [
    DynamicGridComponent,
    DynamicDetailComponent,
    DynamicListDetailComponent
  ],
  exports: [
    DynamicGridComponent,
    DynamicDetailComponent,
    DynamicListDetailComponent
  ],
  entryComponents: [

  ]
})
export class DynamicEntityModule {}

export { DynamicGridComponent } from './components/dynamic-grid/dynamic-grid.component';
export { DynamicDetailComponent } from './components/dynamic-detail/dynamic-detail.component';
export { DynamicListDetailComponent } from './components/dynamic-list-detail/dynamic-list-detail.component';



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/dynamic-entity/dynamic-entity.module.ts